export const searchData = {
  fields: {
    autoComplete: {
      fields: {
        fieldType: {
          value: 'AutoComplete',
        },
        fieldName: {
          value: 'search_bar',
        },
        fieldLabel: {
          value: '',
        },
        defaultValue: {
          value: 'Start typing here',
        },
        isRequired: {
          value: true,
        },
        selectedValue: {
          value: '',
        },
        placeHolder: {
          value: '',
        },
        validationMessage: {
          url:
            '/Site-Content/Data/VADForms/Datasources/ValidationMessages/FieldIsRequired',
          fields: {
            displayText: {
              value: 'Field is required.',
            },
            key: {
              value: '',
            },
          },
        },
      },
    },
  },
};
